<template>
  <div class="el-section">
    <div
      class="emd-container _highlight_header _header_spaced _footer_spaced_sm"
    >
      <div class="emd-container__header">
        <h2 class="emd-text _size_section">
          {{ $t('subscription.invoices.title') }}
        </h2>
      </div>
      <div
        v-if="loadingList"
        class="eu-pa_6 eu-align_center"
      >
        <emd-loader :type="'_invert'"></emd-loader>
      </div>
      <div
        v-else
        class="emd-table-responsive"
      >
        <Table
          :fields="fields"
          :items="invoices.items"
          :toDetail="permissionIsEnabled('subscription:get') && toDetail"
        ></Table>
        <empty-list
          v-if="!loadingList && showEmptyList()"
          entity="subscriptions"
        ></empty-list>
      </div>
      <pagination
        v-if="!loadingList"
        :pagination="invoices.pagination"
        :totalShowing="totalItems"
        :type="'list'"
        :action="action"
      ></pagination>
    </div>
  </div>
</template>
<script>
import { EmdLoader } from 'emerald-vue/src/components'
import EmptyList from '@/components/project/globals/EmptyList.vue'
import Table from '@/components/project/molecules/Table.vue'
import Pagination from '@/components/project/globals/Pagination.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'SubscriptionInvoices',
  components: {
    EmdLoader,
    EmptyList,
    Table,
    Pagination
  },
  data () {
    return {
      action: 'GET_INVOICES',
      fields: [
        {
          id: 'code',
          label: 'subscription.invoices.code',
          type: 'text'
        },
        {
          id: 'customer.name',
          label: 'subscription.invoices.customer',
          type: 'text'
        },
        {
          id: 'status',
          label: 'subscription.invoices.status',
          type: 'status'
        },
        {
          id: 'amount',
          label: 'subscription.invoices.amount',
          type: 'text'
        },
        {
          id: 'due_at',
          label: 'subscription.invoices.due-at',
          type: 'date',
          format: 'date'
        },
        {
          id: 'payment_method',
          label: 'subscription.invoices.payment-method',
          type: 'text'
        }
      ],
      toDetail: {
        name: 'invoicesDetail',
        params: {
          id: 'id'
        }
      }
    }
  },
  computed: {
    ...mapGetters(['merchant', 'account', 'invoices', 'loadingListInvoices']),
    totalItems () {
      return this.invoices.items.length
    },
    loadingList () {
      return this.loadingListInvoices
    }
  },
  methods: {
    showEmptyList () {
      return (
        !this.loadingList &&
        this.invoices.pagination &&
        this.invoices.pagination.total_items === 0
      )
    },
    permissionIsEnabled (action) {
      return this.$store.getters.permissionIsEnabled(action)
    }
  },
  created () {
    const query = {
      subscription_id: this.$route.params.id,
      page: this.$route.query.page || 1
    }
    this.$router.replace({ query: query }).catch(err => err)
    const params = {
      merchantId: this.merchant.id,
      accountId: this.account.id,
      query
    }
    this.$store.dispatch('GET_INVOICES', params)
  }
}
</script>
